'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitSendSellerMessage = exports.getUiSendSellerMessage = exports.SEND_SELLER_MESSAGE_SUCCESS = exports.SEND_SELLER_MESSAGE_REQUEST = exports.SEND_SELLER_MESSAGE_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = require('./modal');

var _api = require('../api');

var _reselect = require('reselect');

var _user = require('./user');

var _config = require('../modules/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SEND_SELLER_MESSAGE_FAIL = exports.SEND_SELLER_MESSAGE_FAIL = 'la/ui/sendSellerMessage/FAIL';
var SEND_SELLER_MESSAGE_REQUEST = exports.SEND_SELLER_MESSAGE_REQUEST = 'la/ui/sendSellerMessage/REQUEST';
var SEND_SELLER_MESSAGE_SUCCESS = exports.SEND_SELLER_MESSAGE_SUCCESS = 'la/ui/sendSellerMessage/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL:
        case _modal.OPEN_SEND_SELLER_MESSAGE_MODAL:
            return (0, _extends3.default)({}, state, {
                messageDetails: action.payload.messageDetails,
                sellerId: action.payload.sellerId,
                sellerName: action.payload.sellerName,
                subject: action.payload.subject,
                title: action.payload.title
            });
        case SEND_SELLER_MESSAGE_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                submitted: true,
                success: false
            });
        case _modal.DISMISS_MODAL:
            return (0, _extends3.default)({}, state, {
                success: false
            });
        case SEND_SELLER_MESSAGE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case SEND_SELLER_MESSAGE_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.sendSellerMessage;
};

var getUiSendSellerMessage = exports.getUiSendSellerMessage = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitSendSellerMessage = exports.submitSendSellerMessage = function submitSendSellerMessage(messageDetails) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: SEND_SELLER_MESSAGE_REQUEST
                            });
                            _context.next = 7;
                            return _api.Seller.postMessage({ authToken: authToken, deployment: deployment, messageDetails: messageDetails });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                payload: response,
                                type: SEND_SELLER_MESSAGE_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: SEND_SELLER_MESSAGE_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/sendSellerMessage.js
// module id = 7IsP
// module chunks = 57